import axios from "axios";
import { getFilenameFromHeader, sanitizeFilters } from "./reportUtils";
import { toast } from "react-toastify";

// export const isAuthorised = (officer, roleValues=[], permissionValues=[], moduleConfig) => {
//     if (!moduleConfig) return false;

//     const hasPermission = moduleConfig.permissions?.some(permission =>
//         permissionValues.includes(permission)
//     );

//     const hasRole = moduleConfig.roles?.some(role =>
//         roleValues.includes(role)
//     );

//     return Boolean(hasPermission && hasRole);;
// }


/**
 * isAuthorised
 *
 * Returns true if the officer satisfies BOTH:
 *   - has one of the required roles  (OR logic within roles[])
 *   - has one of the required permissions (OR logic within permissions[])
 *
 * If a column rule has no roles array → role check is skipped.
 * If a column rule has no permissions array → permission check is skipped.
 *
 * @param {Object} officer       - logged-in officer object
 * @param {string} columnKey     - e.g. "ro_name"
 * @param {Object} moduleConfig  - e.g. APPLICATION_COLUMN_RULES
 * @returns {boolean}
 */
// export const isAuthorised = (officer, columnKey, moduleConfig) => {
export const isAuthorised = (officer, componentConfig) => {
    // if (!officer || !moduleConfig?.[columnKey]) return false;
    if (!officer || !componentConfig) return false;

    const officerRole = officer?.roleMaster?.short_name;
    const officerPermissions = officer?.permissions || [];
    const officerPermissionIds = officerPermissions?.map(p => Number(p.permission_id)) || [];
    const officerPermissionCodes = officerPermissions?.map(p => p.permission_code) || [];

    // const columnRules = moduleConfig[columnKey];
    const columnRules = componentConfig;

    // const hasRole = columnRules.roles?.includes(officerRole);

    const hasPermission = columnRules.permissions?.some(permission =>
        // officerPermissionIds.includes(permission?.permission_id)
        officerPermissionCodes.includes(permission?.permission_code)
    );

    // return hasRole && hasPermission;
    return hasPermission;
};

/**
 * getAuthorisedColumns
 *
 * Filters a list of column keys down to only those the officer is authorised for.
 *
 * @param {Object}   officer       - logged-in officer
 * @param {Object}   moduleConfig  - e.g. APPLICATION_COLUMN_RULES
 * @param {string[]} columns       - column keys to check
 * @returns {string[]}             - subset of columns the officer can edit
 */
export const getAuthorisedColumns = (officer, moduleConfig, columns = []) => {
    return columns.filter(column =>
        isAuthorised(officer, column, moduleConfig)
    );
};

export const downloadFile = async (filename, endpoint, filters, fileExt) => {
    let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    let authToken = tokens?.token || null;

    if (!authToken) {
        toast.error("Invalid or missing token");
        return;
    }

    let headers = {
        'Authorization': `Bearer ${authToken}`,
        'Accept': fileExt == "xlsx"
            ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            : "text/csv"
    }

    if (filename === 'audit_log' && !endpoint) {
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/applications/history/${filters?.application_id}`;
    }

    let queryParams;
    const formattedDate = new Date().toLocaleDateString("en-GB").replace(/\//g, "-");

    if (endpoint.includes('/applications/get-all-applications')) {
        let apiFilters = { ...filters };

        if (apiFilters.globalSearch) {
            const queryStr = apiFilters.globalSearch.trim();
            const lowerQuery = queryStr.toLowerCase();

            const uuidRegex =
                /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
            const isApplicationId = uuidRegex.test(queryStr);

            if (isApplicationId) {
                apiFilters.application_id = queryStr;
                apiFilters.seeds_id = '';
            } else if (/^sfc\d{1,5}$/i.test(queryStr)) {
                // It's an RO ID like SFC00012
                apiFilters.ro_id = queryStr.toUpperCase();
                apiFilters.seeds_id = '';
            } else if (/^(sfc|app|seeds|sfl)\d{6,}$/i.test(queryStr)) {
                // It's an Application Number like SFC00000428
                apiFilters.seeds_id = queryStr.toUpperCase();
                apiFilters.application_id = '';
                apiFilters.branch_name = '';
                apiFilters.branch_code = '';
            } else {
                // Try to match as branch name/code
                let activeBranches = [];
                try {
                    const response = await axios.get(
                        `${process.env.REACT_APP_API_BASE_URL}/officer/get-branch-report?page=1&limit=2000`,
                        { headers },
                    );
                    activeBranches = response?.data?.data?.branch_data || [];
                } catch (e) {
                    console.error('Failed to fetch branches in Applications thunk', e);
                }

                const exactMatches = activeBranches.filter(
                    (b) =>
                        (b.branch_name &&
                            b.branch_name.trim().toLowerCase() === lowerQuery) ||
                        (b.branch_code &&
                            b.branch_code.trim().toLowerCase() === lowerQuery),
                );

                let matchedBranch =
                    exactMatches.length === 1 ? exactMatches[0] : null;

                if (!matchedBranch && lowerQuery.length >= 3) {
                    const partialMatches = activeBranches.filter(
                        (b) =>
                            (b.branch_name &&
                                b.branch_name.trim().toLowerCase().includes(lowerQuery)) ||
                            (b.branch_code &&
                                b.branch_code.trim().toLowerCase().includes(lowerQuery)),
                    );
                    if (partialMatches.length === 1) {
                        matchedBranch = partialMatches[0];
                    }
                }

                if (matchedBranch) {
                    // Matched a branch - convert to branch search
                    apiFilters.branch_name = matchedBranch.branch_name;
                    apiFilters.branch_code = matchedBranch.branch_code || '';
                    apiFilters.seeds_id = '';
                    apiFilters.application_id = '';
                    apiFilters.parent_stage_name = '';
                    apiFilters.application_stage_name = '';
                } else {
                    // Check if it matches Application Number (seeds_id) format (e.g. contains hyphens or starts with typical prefixes)
                    if (/^(sfc|app|seeds|sfl)[-]/i.test(queryStr) || queryStr.includes('-')) {
                        apiFilters.seeds_id = queryStr.toUpperCase();
                        apiFilters.application_id = '';
                        apiFilters.branch_name = '';
                        apiFilters.branch_code = '';
                    } else {
                        // No specialized match - treat as global search
                        apiFilters.global_search = queryStr;
                        apiFilters.seeds_id = '';
                        apiFilters.application_id = '';
                        apiFilters.branch_name = '';
                        apiFilters.branch_code = '';
                    }
                }
            }
            delete apiFilters.globalSearch;
        }

        if (apiFilters.seeds_id) {
            apiFilters.seeds_id = apiFilters.seeds_id.trim().toUpperCase();
        }
        if (apiFilters.ro_id) {
            apiFilters.ro_id = apiFilters.ro_id.trim().toUpperCase();
        }

        queryParams = new URLSearchParams({
            filters: JSON.stringify(apiFilters),
            is_download: true
        });
    }
    else {
        const cleanedFilters = sanitizeFilters(filters);

        // const queryParams = new URLSearchParams({
        //     ...cleanedFilters,
        //     is_download: true
        // });
        queryParams = new URLSearchParams({
            ...cleanedFilters,
            is_download: true
        });
    }


    try {
        const response = await axios.get(`${endpoint}?${queryParams.toString()}`, {
            headers,
            responseType: "blob"    // for CSV/PDF/Excel 
        });

        const disposition = response.headers["content-disposition"];
        console.log({ disposition });

        const serverFilename = getFilenameFromHeader(disposition);
        console.log({ serverFilename });

        const finalFilename = serverFilename || (fileExt == 'xlsx' ? `${filename}_${formattedDate}.xlsx` : `${filename}_${formattedDate}.csv`);

        console.log("Response headers:", response.headers);
        console.log("Response raw data:", response.data);

        // const blob = new Blob([response.data], { type: "text/csv" });
        const blob = new Blob([response.data], {
            type: response.headers["content-type"]
        });
        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = blobUrl;

        link.setAttribute('download', finalFilename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
        console.log("Download Error: ", error);

        let errorMessage = "Download failed";

        try {
            // Attempt to parse the blob error message
            const reader = new FileReader();
            reader.onload = () => {
                try {
                    const parsed = JSON.parse(reader.result);
                    errorMessage = parsed?.message || errorMessage;
                    console.log("error: ", errorMessage);
                    toast.error(errorMessage);
                } catch {
                    toast.error(errorMessage);
                }
            };
            reader.readAsText(error.response.data);
        } catch {
            toast.error(errorMessage);
        }
    }
}

export const resetForm = (setFunction, initialValue) => {
    setFunction(initialValue);
}

export const maskAccountNumber = (accountNumber) => {
    if (!accountNumber) return "";

    const accountStr = String(accountNumber);

    if (accountStr.length <= 4) {
        return accountStr;
    }

    return "*".repeat(accountStr.length - 4) + accountStr.slice(-4);
};


export const resetFiltersDefault = (filters, filterConfig) => {
    return Object.keys(filters).reduce((acc, key) => {
        const config = filterConfig.find(item => item.key === key);

        acc[key] = config ? config.defaultValue : filters[key];
        return acc;
    }, {});
}

export const populateFiltersIntoQueryParams = (filters = {}) => {
    const queryParams = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
        // Handle boolean values
        if (typeof value === "boolean") {
            queryParams.append(key, value);
            return;
        }

        // Handle arrays (multiselects)
        if (Array.isArray(value)) {
            value.forEach(val => {
                if (val) {
                    queryParams.append(key, val);
                }
            });
            return;
        }

        // Handle normal values
        if (value !== null && value !== undefined && value !== "") {
            queryParams.append(key, value);
        }
    });

    return queryParams;
}

export const handleCopyToClipboard = async (link) => {
    try {
        await navigator.clipboard.writeText(link);

        return {
            success: true
        };
    } catch (err) {
        console.error("Failed to copy:", err);
        return {
            success: false
        };
    }
}